import React from "react";
const Terms = () => {
    return (
        <>
            <div class="_blog_nft_hero_wrapper">
                <div class="container">
                    <div class="row">
                        <div class="col-12">
                            <h1 class="_blog_nft_hero_title">Terms Of Service</h1>
                        </div>
                    </div>
                    <div class="_main_terms">
                        <div class="row">
                            <div class="col-12">
                                <p class="_main_terms_date">Last Updated: December 31, 2021</p>
                                <p class="_main_terms_txt">Contrary to popular belief, Lorem Ipsum is not simply random text.
                                    It has roots in a piece of
                                    classical Latin literature from 45 BC, making it over 2000 years old. Richard McClintock, a
                                    Latin professor at Hampden-Sydney College in Virginia, looked up one of the more obscure
                                    Latin words, consectetur, from a Lorem Ipsum passage, and going through the cites of the
                                    word in classical literature, discovered the undoubtable source. Lorem Ipsum comes from
                                    sections 1.10.32 and 1.10.33 of "de Finibus Bonorum et Malorum" (The Extremes of Good and
                                    Evil) by Cicero, written in 45 BC. This book is a treatise on the theory of ethics, very
                                    popular during the Renaissance. The first line of Lorem Ipsum, "Lorem ipsum dolor sit
                                    amet..", comes from a line in section 1.10.32.

                                    The standard chunk of Lorem Ipsum used since the 1500s is reproduced below for those
                                    interested. Sections 1.10.32 and 1.10.33 from "de Finibus Bonorum et Malorum" by Cicero are
                                    also reproduced in their exact original form, accompanied by English versions from the 1914
                                    translation by H. Rackham.</p>
                                <a href="#0" class="_blog_card_link">Read more</a>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}
export default Terms;